module.exports = {
  "container": {
    "position": "fixed",
    "zIndex": 99999
  },
  "dof-mask": {
    "position": "fixed",
    "zIndex": 1003
  },
  "mask-bottom": {
    "marginTop": "92",
    "backgroundColor": "rgba(0,0,0,0)",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "closeIcon": {
    "width": "70",
    "height": "70",
    "zIndex": 999
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-b2c3bef6!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-mask/index.vue
// module id = 530
// module chunks = 0 1